import { Chain } from "chainConfigs";
import { forwardRef } from "react";

const withCoinAvatar = (Component: React.ComponentType<any>) => {
  return forwardRef(
    (
      {
        size = 32,
        badgeSize = 16,
        iconUri,
        chain,
        badgeProps,
        ...props
      }: {
        size?: number;
        badgeSize?: number;
        iconUri: string;
        chain?: Chain;
        badgeProps?: any;
      },
      ref,
    ) => {
      return (
        <Component
          ref={ref}
          size={size}
          badgeSize={badgeSize}
          iconUri={iconUri}
          chain={chain}
          badgeProps={badgeProps}
          {...props}
        />
      );
    },
  );
};

export default withCoinAvatar;
